enum EFactBatchStatus {
    Running = 1,
    PendingValidation = 2,
    RejectionStructural = 3,
    RejectionBlocking = 4,
    RejectionFivePercent = 5,
    Validated = 6,
    Error = 7,
    PartiallyValidated = 8,
    Pending = 9,
    Cancelled = 10,
    Waiting = 11,
    ReceivedByIO = 12,
}

export default EFactBatchStatus;
